import isEmpty from 'lodash/isEmpty';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import Region from '@/creditflowresearch/domain/Region';
import Market from '@/creditflowresearch/domain/Market';

export const getDefaultRegionId = (
  availableRegions: string[],
  fallbackId: string = Region.getDefaultId(),
): string => {
  if (isEmpty(availableRegions) || availableRegions.includes(fallbackId)) {
    return fallbackId;
  }

  return availableRegions[0];
};

export const findRegionById = (
  regions: IRegion[],
  id: string,
): IRegion | undefined => {
  return regions.find((region) => region.id === id);
};

export const findRegionByAbbreviation = (
  regions: IRegion[],
  abbreviation: string,
): IRegion | undefined => {
  return regions.find((region) => region.abbreviation === abbreviation);
};

export const isAnyProductAvailable = (
  availableProducts: string[],
  productIds: string[],
): boolean => {
  return isEmpty(availableProducts) || productIds.some((id) => availableProducts.includes(id));
};

export const getRegionIdsFromMarkets = (markets: string) => Market.getRegionsByMarkets(markets?.split(',') ?? [])
  .map((r) => r.getId());
